import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DatePicker, Icon, Button, ConfigProvider } from 'antd';
import { debounce } from 'lodash';
import intl from 'react-intl-universal';
import zhCN from 'antd/lib/locale/zh_CN';

class MonthPicker extends Component {
  static propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    defaultValue: PropTypes.object,
    disabled: PropTypes.bool,
    onChange: PropTypes.func
  };

  static defaultProps = {
    className: '',
    label: '',
    disabled: false,
    todayButtonId: '',
    onChange: () => {}
  };

  constructor(props) {
    super(props);

    this.state = {
      date: moment(props.defaultValue || undefined).startOf('month')
    };
  }

  handleOnPreviousMonthClick = () => {
    this.handleOnMonthChange(moment(this.state.date).subtract(1, 'month'));
  };

  handleOnNextMonthClick = () => {
    this.handleOnMonthChange(moment(this.state.date).add(1, 'month'));
  };

  handleOnTodayClick = () => {
    this.handleOnMonthChange(moment());
  };

  handleOnMonthChange = date => {
    const next = moment(date || undefined).startOf('month');
    this.setState({
      date: next
    });
    this.onDateChange(next);
  };

  componentDidUpdate(prevProp) {
    const nextValue = this.props.defaultValue;
    if (nextValue && nextValue !== prevProp.defaultValue && !nextValue.isSame(this.state.date, 'month')) {
      this.setState({ date: moment(nextValue).startOf('month') });
    }
  }

  onDateChange = debounce(date => {
    const { onChange } = this.props;
    onChange(date);
  }, 300);

  render() {
    const { date } = this.state;
    const { className, label, disabled, todayButtonId } = this.props;

    return (
      <div
        className={className}
        style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}
      >
        {label && <label className="el-pageTitle">{label} </label>}
        <Button disabled={disabled} onClick={this.handleOnPreviousMonthClick}>
          <Icon type="backward" />
        </Button>
        <DatePicker.MonthPicker
          style={{ width: '125px' }}
          allowClear={false}
          value={date}
          onChange={this.handleOnMonthChange}
          placeholder="Select month"
          disabled={disabled}
        />
        <Button disabled={disabled} onClick={this.handleOnNextMonthClick}>
          <Icon type="forward" />
        </Button>
        <Button id={todayButtonId} disabled={disabled} type="secondary" onClick={this.handleOnTodayClick}>
          {intl.get('expenses.headerLabels.today').d('Today')}
        </Button>
      </div>
    );
  }
}

export default MonthPicker;
